import { generateUUID } from 'syf-js-utilities/helpers';
import store from './store';
var getAuthHeaders = function () {
    var accessToken = store.get('accessToken', 'session');
    var correlationId = store.get('correlationId', 'session') || '';
    return {
        Authorization: "Bearer ".concat(accessToken),
        'X-SYF-Request-CorrelationId': correlationId,
        'X-SYF-Request-TrackingId': generateUUID()
    };
};
export default getAuthHeaders;
